import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { AuthService } from '../../model/auth-model/auth.service';
import { AppComponent } from '../../app.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserModelService } from '../../model/user-model/user-model.service';
import { environment } from '../../../environments/environment';
import QueryObject, { CommonStatus, Globals, UserRole } from '../../globals/globals';
import { CouponService } from '../../model/coupon/coupon.service';
import { ToastrService } from 'ngx-toastr';
import { SpecialSaleService } from 'src/app/model/special-sale/special-sale.service';
import { CustomTypeAttribute, CommonStatusType,UserType} from 'src/app/globals/custom-types/global-custom-types';
import SystemConstants from 'src/app/util/constants/SystemConstants';
import { UserImageType } from '../user/enums/user-image-type';
import { IGetUser } from 'src/app/interface/user/i-get-user';
import { NotificationApiModel, INotificationList } from 'src/app/interface/notification/i-notfication';
import { Translations } from 'src/app/util/service/internationalization/translations.service';
import { SectionDetailsList } from './constants/section-details-list';
import {  PageUrl} from './enums/section-type'
import { NotificationModelService } from 'src/app/model/notification-model/notification-model.service';

@Component({
    selector: 'app-header',
    templateUrl: '../../view/header/header.component.html',
    styleUrls: ['../../view/header/header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  
  @ViewChild('dropdownMenu', {static:false}) dropdownMenu : ElementRef;
  @ViewChild('messageDropdown', {static:false}) messageDropdown : ElementRef;
  @ViewChild('notificationDropdown', {static:false}) notificationDropdown : ElementRef;
  @ViewChild('profileInfoDropdown', {static:false}) profileInfoDropdown : ElementRef;

  status: boolean = false;
  isUserLoggedIn = false;
  loginUser: IGetUser;
  isMobileNavVisible = false;
  userRole = -1;
  imageCdn = environment.imageCdn.getHost;
  imageBaseUrl = environment.ImageBase;
  notify: boolean
  userData: UserType;
  sAttributes: CustomTypeAttribute<Globals['adminPaginationAttrs'], any>;
  headerWidth: any;
  showHideMoreMenu: boolean;
  userProfileImgage: any;
  inotify = false;
  profileInfoShow :boolean = false;
  activated: CommonStatusType;
  pending: CommonStatusType;
  notificationList: INotificationList[];
  unreadNotificationCounts: number;
  sectionDetailsList: typeof SectionDetailsList = SectionDetailsList;
  sectionIndex: number = -1;
  currentPageUrl: string ;
  showMasqueradeOffset = false;
  isProgramsMenuActive: boolean = false;
  isReportMenuActive: boolean = false;
  isTrackerMenuActive: boolean = false;
  isStoreMenuActive: boolean = false;
  isUnitMenuActive: boolean = false;
  isCouponMenuActive: boolean = false;
  isLocaleMenuActive: boolean = false;
  unreadMessageCounts:number
  systemConstants:SystemConstants;
  showNotificationStatus: number = SystemConstants.DEFAULT_ONE;
  isSectionItems: boolean = false;
  isMessageMenuActive: boolean = false;
  isNotificationMenuActive: boolean = false;
  private activeMenuItem: HTMLElement | null = null;
  isSignupDropdownOpen = false;


  constructor(
    public globals: Globals,
    private comp: AppComponent,
    private authService: AuthService,
    private userModelService: UserModelService,
    private specialModelService: SpecialSaleService,
    private router: Router,
    private couponModelService: CouponService,
    private notificationModelService: NotificationModelService,
    private toastr: ToastrService,
    public translations: Translations,
    private route: ActivatedRoute,
    private closeMenuIcon: ElementRef
    ) {
      this.initializeProperties();
    }

  ngOnInit() {
    this.checkAuthLogin();
    this.getProfileImagesData();
    this.checkPageUrl();
    this.listenForOpenLoginPopup();
    this.listenForSignupPopups();
    this.listenForMerchantSignupQueryParam();
  }

  private listenForOpenLoginPopup(): void {
    this.authService.openLoginPopup$.subscribe((shouldOpen) => {
      if (shouldOpen) {
        this.authService.consumeOpenLoginPopup();
        this.openLogin();
      }
    });
  }

  private listenForSignupPopups(): void {
   this.authService.openUserSignupPopup$.subscribe(() => {
       this.showUserSignup();
    });
    this.authService.openMerchantSignupPopup$.subscribe(() => {
        this.openMerchantSignup();
    });
  }

  /** Open merchant signup when landing with ?signup=true (e.g. deep link from mobile app). */
  private listenForMerchantSignupQueryParam(): void {
    this.handleMerchantSignupQueryParam(this.router.url);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleMerchantSignupQueryParam(event.urlAfterRedirects);
      }
    });
  }

  private handleMerchantSignupQueryParam(url: string): void {
    const signupParam = this.router.parseUrl(url).queryParams['signup'];
    if (signupParam !== 'true' || this.authService.isAuthenticated()) {
      return;
    }
    // Navigating to the signup page drops the ?signup=true param on its own.
    this.openMerchantSignup();
  }

  initializeProperties() {
    this.userData = UserRole;
    this.activated = CommonStatus.ACTIVE;
    this.pending = CommonStatus.PENDING;
    this.systemConstants = SystemConstants
  }

  getProfileImagesData() {
    this.userModelService.profileImageData$.subscribe(data => {
      if(data) {
        this.userProfileImgage = data;
      }
      else {
        this.userProfileImgage = null;
        this.getLogInUser()
      }
    });
  }

  checkAuthLogin() {
    this.authService.isLoggedInForHeaderSubject$.subscribe((isLoggedInForHeader) => {
      const isLoggedInSuccessfully  = JSON.parse(localStorage.getItem('isLoggedInSuccessfully')) as boolean;
      if ((!isLoggedInForHeader || isLoggedInSuccessfully)) {
        this.sAttributes = Object.assign({}, new Globals().adminPaginationAttrs);
        const loginUserData = this.authService.getUserData();
        this.loginUser = loginUserData.data;
        this.userRole = loginUserData.data.role;
        this.updateMasqueradeOffset();
        this.getUnreadNotificationCounts();
        this.getMessageCount(false)
        this.getLogInUser();
        if(this.userRole === this.userData.SUPER_ADMIN || this.userRole === this.userData.MERCHANT) {
          setTimeout(() => {
            let c = document.getElementById("teleporter").children;
            let moveHtml = [];
            let appendHTML;
            for (let i = 0; i < c.length; i++) {
              moveHtml.push(c[i].outerHTML)
              appendHTML = appendHTML + moveHtml[i];
            }
            appendHTML = appendHTML.replace("undefined", "");
            document.getElementById("receiver").innerHTML = appendHTML
            let elementLiList = document.getElementById("receiver").children;
            for (let i = 0; i < elementLiList.length; i++) {
              let li = elementLiList[i];
              let liLinkTag  = li.querySelector("a");
              if (liLinkTag && liLinkTag.classList.contains("active")) {
                  liLinkTag.classList.add("active");
                  this.activeMenuItem = liLinkTag;
              }
          }
            for (let k = 0; k < elementLiList.length; k++) {
              elementLiList[k].classList.add("d-none")
            }
            this.headerMenuResponsive()
          }, 1000);
        }
      } else {
        this.hideHeaderForLoggedInUser();
      }
    }, error => {
      this.loginUser = {} as IGetUser;
      this.hideHeaderForLoggedInUser();
      console.error(error);
    });
  }

  clickEvent(){
    this.status = !this.status;
  }

  /*
 * Method for Ng class for app component
 */
  public mobRes(): void {
    this.comp.addSlideCls = this.comp.addSlideCls ? false : true;
    this.isMobileNavVisible = this.isMobileNavVisible ? false : true;

  }

  getImageSrcByImageType(imageDetails: { imageType: string, image: string }) {
    return this.userModelService.getImageSrcByImageType({ imageType: imageDetails.imageType as UserImageType, image: imageDetails.image });
  }

  
  isImageCdnByImageType(imageType: string) {
    return this.userModelService.isImageCdnByImageType(imageType as UserImageType);
  }
  openLogin() {
    this.isSignupDropdownOpen = false;
    void this.router.navigate(['/login']);
  }

  openContact() {
    this.isSignupDropdownOpen = false;
    void this.router.navigate(['/contact-us']);
  }

  openMerchantSignup() {
    this.isSignupDropdownOpen = false;
    void this.router.navigate(['/merchant-signup']);
  }

  /**
   * This is used to logout and clear all cache.
   * Redirect at home page.
   */
  logout() {
    this.userModelService.logoutUser({}).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.authService.logout()
        this.userRole = -1;
        this.mobRes();
        this.profileInfoShow = false;
        this.toastr.success(SystemConstants.SUCCESS , SystemConstants.LOGOUT_MSG);
      } else {
      }
    });
   
  }

  getLogInUser(): void {
    if(this.loginUser){
    this.userModelService.finduserById( { _id: this.loginUser._id } ).subscribe(res => {
      if (res && res.status === 'OKAY') {
        this.loginUser = res.data ? res.data : {};
        this.userProfileImgage = null
      }
    }, err => {
    });
  }
  }

  /** UserContact row from merged /coupon-counter-msz (no counterUserData). */
  isUserContactRow(item: any): boolean {
    return item && !item.counterUserData && (item.name != null || item.email != null) && item.message != null;
  }

  getMessageList() {
    const queryObj:QueryObject= {
      limit:SystemConstants.DEFAULT_LIMIT_OF_PAGE_ITEMS
    };
    this.notificationModelService.getNotificationMessagesList(queryObj).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        const rows = Array.isArray(res.data) ? res.data : [];
        this.sAttributes.messageItems = rows.slice(0, SystemConstants.HEADER_MESSAGE_PREVIEW_COUNT);
        this.getMessageCount(false);
      } else {
        this.toastr.error(SystemConstants.ERROR, res.errMsg);
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(SystemConstants.ERROR, err.error.error.message);
      }
    });
  }
  getMessageCount(isMessageRead: boolean) {
    const queryObj: QueryObject = { isMessageRead };
    this.notificationModelService.getMessagesCount(queryObj).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.unreadMessageCounts = typeof res.data === 'number' ? res.data : 0;
      } else {
        this.toastr.error(SystemConstants.ERROR, res.errMsg);
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(SystemConstants.ERROR, err.error.error.message);
      }
    });
  }

  getMessageCountAndList(){
    this.notify = true;
    this.profileInfoShow = false;
    this.getMessageList();
  }
  getUnreadNotificationCountAndList(){
    this.getUnreadNotificationList()
    this.getUnreadNotificationCounts()
    this.profileInfoShow = false;
  }

  setNotificationDropdownState(nextState: boolean): void {
    const wasOpen = this.inotify;
    this.inotify = nextState;
    if (wasOpen && !nextState) {
      this.markNotificationsAsReadOnClose();
    }
  }

  getUnreadNotificationList() {
    // const queryObj = {} as Partial<NotificationApiModel>;
    // if (this.loginUser.role === UserRole.SUPER_ADMIN) {
    //   queryObj.userRole = this.loginUser.role;
    // } else {
    //   queryObj.memberId = String(this.loginUser._id);
    //   queryObj.userRole = this.loginUser.role as UserRoleTypes;
    // }
    // queryObj.status = CommonStatus.PENDING
    // queryObj.limit = this.sAttributes.halfLimit;
    // queryObj.memberId = String(this.loginUser._id);
    let queryObj:QueryObject = {
      memberId:String(this.loginUser._id)
    }
    this.specialModelService.getNotificationList(queryObj).subscribe(res => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.notificationList = res.data;
      } else {
        this.toastr.error(SystemConstants.ERROR, res.errMsg);
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(SystemConstants.ERROR, err.error.error.message);
      }
    });
  }
  ngAfterViewInit(): void {
  setTimeout(() => {
    this.headerMenuResponsive();
  }, 0);
}
  headerMenuResponsive(): void {
  const teleporter = document.getElementById('teleporter');
  const addMenu = document.getElementById('addmenu');
  const receiverElement = document.getElementById('receiver');

  if (!teleporter || !addMenu || !receiverElement) {
    return;
  }

  this.headerWidth = teleporter.offsetWidth;

  if (!this.headerWidth) {
    return;
  }

  const menuItems = Array.from(
    teleporter.children
  ) as HTMLElement[];

  const receiverItems = Array.from(
    receiverElement.children
  ) as HTMLElement[];

  let sum = 0;

  // Reset first
  menuItems.forEach((item) => {
    item.classList.remove('no-show');
  });

  receiverItems.forEach((item) => {
    item.classList.add('d-none');
  });

  menuItems.forEach((item, index) => {
    sum += item.clientWidth;

    if (sum >= this.headerWidth) {
      item.classList.add('no-show');

      receiverItems[index]?.classList.remove('d-none');
    }
  });

  const hiddenItems = menuItems.filter((item) =>
    item.classList.contains('no-show')
  );

  addMenu.classList.toggle(
    'd-none',
    hiddenItems.length === 0
  );
}
  handleItemClick(event: Event) {
  event.preventDefault();
  const clickedItem = event.target as HTMLElement; 
  const selectedRoute = clickedItem.getAttribute('href');
  if (selectedRoute) {
    if (this.activeMenuItem) {
      this.activeMenuItem.classList.remove('active');
    }
    this.router.navigateByUrl(selectedRoute);
    clickedItem.classList.add('active');
    this.activeMenuItem = clickedItem;
  }
}

  hideHeaderForLoggedInUser() {
    this.userRole = -1;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (this.isUserLoggedIn) {
      if (this.userRole === this.userData.SUPER_ADMIN || this.userRole === this.userData.MERCHANT) {
        this.headerMenuResponsive()
      }
    }
  }

  updateNotification(notification: NotificationApiModel, status: CommonStatusType): void {
    this.specialModelService.updateNotification({status}, {id: notification._id}).subscribe((res) => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        void this.router.navigate([`/${notification.redirectLink.web}`]);
      } else {
        this.toastr.error(SystemConstants.ERROR, res.errMsg);
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(SystemConstants.ERROR_MSG, err.error.error.message);
      }
    });
    this.setNotificationDropdownState(false);
  }
 handleNotificationClick(notificationData: any) {
  this.updateNotification(notificationData, this.activated);

  if (notificationData.message.toLowerCase().includes('crash')) {
    const crashId = notificationData.crashId;
    this.router.navigate(['/crash-report'], { queryParams: { id: crashId } });
  }
}

  getUnreadNotificationCounts() {
    // const queryObj = {} as Partial<NotificationApiModel>;
    // if (this.loginUser.role === UserRole.SUPER_ADMIN) {
    //   queryObj.userRole = this.loginUser.role;
    // } else {
    //   queryObj.recipientId = String(this.loginUser._id);
    //   queryObj.userRole = this.loginUser.role as UserRoleTypes;
    // }
    // queryObj.status = CommonStatus.PENDING;
    let queryObj:QueryObject = {
      memberId:String(this.loginUser._id)
    } 
    this.specialModelService.getUnreadNotificationCounts(queryObj).subscribe((res) => {
      if (res && res.status === SystemConstants.OKAY_MSG) {
        this.unreadNotificationCounts = res.data || 0;
      } else {
        this.toastr.error(SystemConstants.ERROR, res.errMsg);
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(SystemConstants.ERROR_MSG, err.error.error.message);
      }
    });
  }

  private markNotificationsAsReadOnClose(): void {
    if (!this.unreadNotificationCounts || this.unreadNotificationCounts <= 0) {
      return;
    }

    this.specialModelService.markAllNotificationsAsRead().subscribe({
      next: () => {
        this.unreadNotificationCounts = 0;
        this.notificationList = (this.notificationList || []).map((notificationData) => ({
          ...notificationData,
          isNotificationRead: true,
        }));
      },
      error: () => {
        this.getUnreadNotificationCounts();
      },
    });
  }

  hideDropDownList(){
    this.showHideMoreMenu = false;
    this.profileInfoShow = false;
    if (this.activeMenuItem) {
      this.activeMenuItem.classList.remove('active');
    }
  }

  @HostListener('window:click', ['$event'])
  closeDropdown(event:Event){
    if(!this.dropdownMenu || !this.dropdownMenu.nativeElement.contains(event.target)){
      this.showHideMoreMenu = false;
    }
    if(!this.messageDropdown || !this.messageDropdown.nativeElement.contains(event.target)){
      this.notify = false;
    }
    if(!this.notificationDropdown || !this.notificationDropdown.nativeElement.contains(event.target)){
      this.setNotificationDropdownState(false);
    }
    if(!this.profileInfoDropdown || !this.profileInfoDropdown.nativeElement.contains(event.target)){
      this.profileInfoShow = false;
    }
    if (!this.closeMenuIcon.nativeElement.contains(event.target) ) {
      this.comp.addSlideCls =  false;
      this.isMobileNavVisible = false;
    }
  }
  
  scrollTo(id:string, index:number) {
    if(document.querySelector('#' + id)) {
     document.querySelector('#' + id).scrollIntoView({behavior: 'smooth'});
      this.sectionIndex = index;
    } else {
      this.router.navigate(['/'], { fragment: id });
    }
    this.mobRes();
  }
  
  removeActiveCls(){
    this.sectionIndex = -1;
  }

  checkPageUrl(){
    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {
          this.currentPageUrl = this.router.url;
          this.updateMasqueradeOffset();
          this.programsMenuActive(this.router.url);
          this.reportMenuActive(this.router.url);
          this.trackerMenuActive(this.router.url);
          this.storeMenuActive(this.router.url);
          this.unitMenuActive(this.router.url);
          this.couponMenuActive(this.router.url);
          this.localeMenuActive(this.router.url);
          this.homeMenuActive(this.router.url);
          this.messageMenuActive(this.router.url);
          this.notificationMenuActive(this.router.url);
        }
      }
    );
  }

  private updateMasqueradeOffset(): void {
    const role = this.userRole;
    const isAdminPortalUser =
      role === this.userData?.SUPER_ADMIN || role === this.userData?.LOCALE_ADMIN;
    const url = this.currentPageUrl || this.router.url || '';
    const onUserShell = url === '/user' || url.startsWith('/user/');
    this.showMasqueradeOffset = Boolean(isAdminPortalUser && !onUserShell);
  }

  homeMenuActive(pageUrl:string){
    if(pageUrl === '/' || pageUrl === PageUrl.SECTION_ONE || pageUrl === PageUrl.SECTION_TWO || pageUrl === PageUrl.SECTION_THREE || pageUrl === PageUrl.SECTION_FOUR){
      this.isSectionItems = true;
    }else{
     this.isSectionItems = false;
    }
   }

  programsMenuActive(pageUrl:string){
      if(pageUrl === PageUrl.MANAGE_CHALLENGE_CATEGORIES || pageUrl === PageUrl.MANAGE_MAP){
        this.isProgramsMenuActive = true;
      }else{
        this.isProgramsMenuActive = false;
      }
  }

  reportMenuActive(pageUrl:string){
    if (pageUrl === PageUrl.EARN_REPORT || pageUrl === PageUrl.MERCHANT_REPORT || pageUrl === PageUrl.COMMUNITY_REPORT || pageUrl === PageUrl.USER_REPORT || pageUrl === PageUrl.COUPON_REPORT || pageUrl === PageUrl.PAYMENT_REPORT || pageUrl === PageUrl.STORE_REPORT) {
      this.isReportMenuActive = true;
    }else{
      this.isReportMenuActive = false;
    }
  }

  trackerMenuActive(pageUrl:string){
    if(pageUrl === PageUrl.MANAGE_TRACKER_TYPE){
      this.isTrackerMenuActive = true;
    }else{
      this.isTrackerMenuActive = false;
    }
  }

  storeMenuActive(pageUrl:string){
    if(pageUrl === PageUrl.STORE_CATEGORIES || pageUrl === PageUrl.ADMIN_STORE){
      this.isStoreMenuActive = true;
    }else{
      this.isStoreMenuActive = false;
    }
  }

  unitMenuActive(pageUrl:string){
    if(pageUrl === PageUrl.UNIT_TYPE || pageUrl === PageUrl.MANAGE_UNIT){
      this.isUnitMenuActive = true;
    }else{
      this.isUnitMenuActive = false;
    }
  }

  couponMenuActive(pageUrl:string){
    if(pageUrl === PageUrl.COUPON_CATEGORY || pageUrl === PageUrl.COUPON){
      this.isCouponMenuActive = true;
    }else{
      this.isCouponMenuActive = false;
    }
  }

  localeMenuActive(pageUrl:string){
    if(pageUrl === PageUrl.CUSTOM_FIELD){
      this.isLocaleMenuActive = true;
    }else{
      this.isLocaleMenuActive = false;
    }
  }

  messageMenuActive(pageUrl:string){
    if(pageUrl === PageUrl.MESSAGE){
      this.isMessageMenuActive = true;
    }else{
      this.isMessageMenuActive = false;
    }
  }

  notificationMenuActive(pageUrl:string){
    if(pageUrl === PageUrl.NOTIFICATION){
      this.isNotificationMenuActive = true;
    }else{
      this.isNotificationMenuActive = false;
    }
  }
  showUserSignup() {
    this.isSignupDropdownOpen = false;
    void this.router.navigate(['/user-signup']);
  }

}


